import { useMutation } from '@tanstack/react-query'

import { axios } from '@apps-common/lib'
import { toastError, toastSuccess } from '@apps-common/lib/toast'
import { ICompanyModel } from '@apps-common/types/portal/company'

export const updateCompany = async (model: ICompanyModel): Promise<ICompanyModel> =>
  axios.post(`/me/UpdateMyCompany`, model).then((res) => res.data?.data)

type Props = {
  model: ICompanyModel
}

export const useUpdateCompany = (notify?: boolean, onSuccess?: (data: ICompanyModel) => void) =>
  useMutation({
    mutationKey: ['updateCompany'],
    mutationFn: ({ model }: Props) => updateCompany(model),
    onSuccess: (data) => {
      if (onSuccess) {
        onSuccess(data)
      }
      if (notify) {
        toastSuccess('Updated company details.')
      }
    },
    onError: () => {
      if (notify) {
        toastError('Failed to update company details.')
      }
    },
    throwOnError: false
  })
